module.exports = __webpack_public_path__ + "43c1ca5602ec13fb012ca0d89cb18983.svg";